import { useState, useEffect } from "react";
import axios from "axios";
import { Pencil } from "lucide-react";
import EditPdf from "./DaynamicDocument";
import { motion } from "framer-motion";

const API_URL = "https://backend.aktcorp.com/relateddocuments"; // ✅ New URL (no :id for fetching all)
const PdfList = () => {
  const [pdfs, setPdfs] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [showPage, setShowPage] = useState(false);

  const jwtToken = localStorage.getItem("authToken"); // ✅ Fetch JWT token

  useEffect(() => {
    const timeout = setTimeout(() => setShowPage(true), 2000);
    return () => clearTimeout(timeout);
  }, []);

  // ✅ Fetch Related Documents with JWT
  useEffect(() => {
    const fetchPdfs = async () => {
      try {
        const response = await axios.get(API_URL, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setPdfs(response.data.data);
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    };

    fetchPdfs();
  }, [jwtToken]);

  if (!showPage) {
    return (
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
        className="w-24 h-24 border-4 border-t-transparent border-blue-600 rounded-full mx-auto mt-32"
      ></motion.div>
    );
  }

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white text-gray-700 rounded-lg mb-7">
      <motion.h2
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-3xl font-bold text-gray-900 bg-clip-text text-center mb-4 text-transparent bg-gradient-to-r from-blue-500 to-purple-500"
      >
        Edit Related Document
      </motion.h2>

      <ul className="space-y-3">
        {pdfs.length > 0 ? (
          pdfs.map((pdf) => (
            <li
              key={pdf.id}
              className="flex items-center justify-between bg-gray-700 p-4 rounded-lg shadow-md hover:bg-gray-800 transition"
            >
              <div className="flex-1">
                <h3 className="font-semibold text-lg text-white">{pdf.title}</h3>
                <p className="text-sm text-white">Category: {pdf.category}</p>
                <p className="text-sm text-white">File Type: {pdf.fileType}</p>
                <p className="text-sm text-white">Language: {pdf.language}</p>
                <button
                  onClick={() => {
                    if (pdf.fileContent) {
                      window.open(pdf.fileContent, "_blank");
                    } else {
                      alert("PDF URL not available");
                      console.error("No fileContent found for this document:", pdf);
                    }
                  }}
                  className="text-blue-400 hover:text-blue-500 text-sm mt-1 underline"
                >
                  Click to View
                </button>
              </div>

              {/* ✅ Pencil Icon to Edit PDF */}
              <button
                type="button"
                onClick={() => setSelectedPdf(pdf)}
                className="p-2 bg-blue-500 rounded-full text-white hover:bg-blue-600 transition"
              >
                <Pencil size={20} />
              </button>
            </li>
          ))
        ) : (
          <p className="text-center text-gray-500">No documents available.</p>
        )}
      </ul>

      {/* ✅ Show EditPdf component */}
      {selectedPdf && <EditPdf pdf={selectedPdf} onClose={() => setSelectedPdf(null)} />}
    </div>
  );
};

export default PdfList;
